import { render, staticRenderFns } from "./AboutClients.vue?vue&type=template&id=7c425cfd&scoped=true&"
import script from "./AboutClients.vue?vue&type=script&lang=js&"
export * from "./AboutClients.vue?vue&type=script&lang=js&"
import style0 from "./AboutClients.vue?vue&type=style&index=0&id=7c425cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c425cfd",
  null
  
)

export default component.exports